const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Pejabat Korporat",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Amalan Veterinar",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Diperlukan",
    },
  },
  salutation: {
    label: "Gelaran",
    placeholder: "Pilih gelaran",
    errors: {
      required: "Gelaran diperlukan",
      invalid: "Pilih gelaran yang sah",
    },
  },
  firstName: {
    label: "Nama pertama",
    placeholder: "Ahmad",
    errors: {
      required: "Nama pertama diperlukan",
      minLength: "Nama pertama mestilah sekurang-kurangnya 2 aksara",
      maxLength: "Nama pertama mestilah maksimum 50 aksara",
    },
  },
  lastName: {
    label: "Nama keluarga",
    placeholder: "Ali",
    errors: {
      required: "Nama keluarga diperlukan",
      minLength: "Nama keluarga mestilah sekurang-kurangnya 2 aksara",
      maxLength: "Nama keluarga mestilah maksimum 50 aksara",
    },
  },
  email: {
    label: "E-mel",
    placeholder: "ahmad.ali@example.com",
    description:
      "Masukkan alamat e-mel peribadi anda, bukan alamat e-mel yang dikongsi.",
    prefixWarningTitle: "Peti mel yang dikongsi dikesan",
    prefixWarningDescription:
      "Kami mengesyorkan menggunakan alamat e-mel peribadi untuk pengalaman yang lebih baik dan peribadi",
    errors: {
      required: "E-mel diperlukan",
      invalidEmail: "Masukkan alamat e-mel yang sah",
      emailAssociatedWithYourAccount:
        "Alamat e-mel anda dikaitkan dengan akaun anda dan tidak boleh diubah.",
    },
  },
  confirmEmail: {
    label: "Sahkan e-mel",
    placeholder: "ahmad.ali@example.com",
    errors: {
      required: "Pengesahan e-mel diperlukan",
      invalidEmail: "Masukkan alamat e-mel yang sah",
      emailMatchError: "Alamat e-mel tidak sepadan",
    },
  },
  password: {
    label: "Kata laluan",
    placeholder: "Masukkan kata laluan anda",
    errors: {
      required: "Kata laluan diperlukan",
    },
  },
  confirmPassword: {
    label: "Sahkan kata laluan",
    placeholder: "Sahkan kata laluansi",
    errors: {
      required: "Pengesahan kata laluan diperlukan",
      passwordMatchError: "Kata laluan tidak sepadan",
    },
  },
  addressLine1: {
    label: "Baris alamat 1",
    placeholder: "Jalan Contoh 123",
    errors: {
      required: "Baris alamat 1 diperlukan",
      minLength: "Baris alamat 1 mestilah sekurang-kurangnya 5 aksara",
      maxLength: "Baris alamat 1 mestilah maksimum 100 aksara",
    },
  },
  addressLine2: {
    label: "Baris alamat 2",
    placeholder: "Apartmen 4B",
    errors: {
      required: "Baris alamat 2 diperlukan",
      maxLength: "Baris alamat 2 mestilah maksimum 100 aksara",
    },
  },
  city: {
    label: "Bandar",
    placeholder: "Kuala Lumpur",
    errors: {
      required: "Bandar diperlukan",
      minLength: "Bandar on oltava sekurang-kurangnya 2 aksara",
      maxLength: "Bandar on oltava maksimum 50 aksara",
    },
  },
  state: {
    label: "Negeri",
    placeholder: "Pilih negeri",
    errors: {
      required: "Negeri diperlukan",
      invalid: "Pilih negeri yang sah",
    },
  },
  jurisdiction: {
    label: "Bidang kuasa",
    placeholder: "Pilih bidang kuasa",
    errors: {
      required: "Bidang kuasa diperlukan",
      invalid: "Pilih bidang kuasa yang sah",
    },
  },
  zipCode: {
    label: "Poskod",
    placeholder: "50000",
    errors: {
      required: "Poskod diperlukan",
      invalid: "Masukkan kod pos yang sah",
    },
  },
  role: {
    label: "Peranan",
    placeholder: "Pilih peranan anda",
    errors: {
      required: "Pilih peranan anda",
      invalid: "Pilih peranan yang sah",
    },
  },
  businessType: {
    label: "Jenis Perniagaan",
    placeholder: "Pilih jenis syarikat",
    errors: {
      required: "Jenis Perniagaan diperlukan",
      invalid: "Pilih jenis syarikat yang sah",
    },
  },
  businessName: {
    label: "Nama Syarikat",
    placeholder: "Masukkan nama syarikat",
    errors: {
      required: "Nama Syarikat diperlukan",
      minLength: "Nama syarikat mestilah sekurang-kurangnya 2 aksara",
      maxLength: "Nama syarikat mestilah maksimum 100 aksara",
    },
  },
  businessSearch: {
    label: "Carian Syarikat:",
    addNewAccount: "Tambah akaun syarikat baharu",
    canNotFindBusiness: "Tidak jumpa syarikat anda?",
    guideline: "Masukkan kod pos anda, kemudian pilih dari senarai di bawah.",
    guidelineForNameSearch:
      "Masukkan nama penuh syarikat, kemudian pilih dari senarai.",
    placeholder: "Di mana anda bekerja?",
    noResults: "Tiada hasil dijumpai",
    searching: "Mencari...",
    selectedBusinessHeading: "Syarikat yang dipilih:",
    selectedBusinessNotCorrect: "Tidak betul?",
    selectedBusinessTryAgain: "Cuba lagi",
    selectedBusinessDismiss: "Tolak syarikat",
    resultsFound: {
      singular: "1 syarikat dijumpai",
      plural: "Beberapa syarikat dijumpai",
    },
    errors: {
      network:
        "Terdapat masalah menyambung ke perkhidmatan carian syarikat. Sila cuba lagi kemudian.",
    },
  },
  explicitConsent: {
    label:
      "Dengan menandai kotak ini, saya menerima syarat penggunaan Elanco dan mengesahkan bahawa Elanco mengumpul dan memproses data peribadi saya mengikut dasar privasi Elanco",
    errors: {
      required: "Persetujuan eksplisit diperlukan",
    },
  },
  explicitSmsConsent: {
    label:
      "Dengan menandakan kotak ini, saya bersetuju untuk menerima komunikasi pemasaran daripada Elanco melalui SMS/mesej teks.",
    errors: {
      required: "Persetujuan SMS diperlukan",
    },
  },
  telephone: {
    label: "Telefon peribadi",
    placeholder: "Masukkan nombor telefon peribadi anda",
    dialCodeLabel: "Kod",
    dialCodePlaceholder: "Cari negara...",
    errors: {
      invalid: "Masukkan nombor telefon yang sah.",
    },
  },
  businessTelephone: {
    label: "Telefon Syarikat",
    placeholder: "Masukkan nombor telefon syarikat",
    dialCodeLabel: "Kod",
    dialCodePlaceholder: "Cari negara...",
    errors: {
      invalid: "Masukkan nombor telefon yang sah.",
    },
  },
  professionalNumber: {
    label: "Nombor Profesional",
    placeholder: "1234567",
    errors: {
      required: "Masukkan nombor profesional",
      maxLength: "Input melebihi had aksara",
    },
  },
  addressSearch: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  businessSearchField: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  checkbox: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  combobox: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  datePicker: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  dateRange: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  dateTime: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  emailField: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  fileInput: {
    errors: {
      required: "Pilih fail",
    },
  },
  number: {
    errors: {
      required: "Masukkan nombor",
      minValue: "Masukkan nilai yang lebih besar daripada nilai minimum",
      maxValue: "Masukkan nilai yang lebih kecil daripada nilai maksimum",
    },
  },
  passwordField: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  rangeSlider: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  select: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  telephoneField: {
    errors: {
      required: "Masukkan nombor sahaja",
      invalidTelephone: "Masukkan nombor telefon yang sah",
      invalidFormat: "Format nombor tidak sah",
    },
  },
  text: {
    errors: {
      required: "Gunakan huruf sahaja (A-Z), nombor (0-9), dan tiada simbol",
      maxLength: "Input melebihi had aksara",
      minLength: "Input mestilah sekurang-kurangnya 2 aksara",
    },
  },
  textarea: {
    characters: "aksara",
  },
  time: {
    errors: {
      required: "Medan ini diperlukan",
    },
  },
  form: {
    errors: {
      generic: "Lomakkeen lähettämisessä tapahtui virhe. Cuba lagi.",
      reportAnIssue: "Laporkan masalah.",
      configuration: "Ralat konfigurasi",
      noFormQuestionsAvailable: "Item borang tidak tersedia.",
      formComponentLoad:
        "Tidak dapat memuatkan komponen borang kerana medan yang tidak disokong.",
      code: "Kod",
      type: "Tyyppi",
      missingRequiredFields:
        "Borang kehilangan medan wajib (E-mel dan/atau Persetujuan). Sila hubungi pentadbir untuk membetulkan konfigurasi borang.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Kebajikan Haiwan - Doktor Veterinar",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Pengeluar - Campuran/Lain-lain",
    id: "producer_mixed_other",
  },
  {
    value: "Retailer",
    label: "Peruncit",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Pengeluar Bebiri",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Doktor haiwan",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Doktor haiwan", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Doktor veterinar, pemilik amalan",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Doktor haiwanavustaja",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Amalan Veterinar - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Amalan Veterinar - Doktor haiwan",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Amalan Veterinar - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Pakar Veterinar",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Doktor haiwan",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Encik",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Encik",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Puan",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Puan",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
